document.addEventListener('click', async event => {
  const button = event.target.closest('[data-oauth-copy]');
  if (!button) return;
  const field = document.getElementById(button.dataset.oauthCopy);
  const status = document.querySelector('.oauth-copy-status');
  if (!field || !status) return;
  button.disabled = true;
  try {
    await navigator.clipboard.writeText(field.value);
    status.textContent = 'Copiado al portapapeles. Compártelo únicamente por un canal seguro.';
  } catch (_) {
    field.focus(); field.select();
    status.textContent = 'No se pudo copiar automáticamente. El valor está seleccionado para copiarlo manualmente.';
  } finally { button.disabled = false; }
});

document.addEventListener('turbolinks:before-cache', () => {
  document.querySelectorAll('.oauth-secret').forEach(details => { details.open = false; });
  const secret = document.getElementById('oauth-client-secret');
  if (secret) { secret.value = ''; secret.removeAttribute('value'); }
});
